<!--节点管理-->
<template>
  <div>
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item :to="{ path: '/cargo/type' }">
        <i class="iconfont icon_home icon-t-1"></i>
        <span>资料管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>节点管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-row mt-0">
        <div class="toolbar-item">
          <el-button type="primary" size="small" @click="goBack" id="auto-0"
            >返回</el-button
          >
        </div>
      </div>
    </div>
    <div class="table-custom-box" id="auto-1">
      <el-table :data="dataList" border>
        <el-table-column
          prop="siteName"
          label="节点名称"
          min-width="400"
        ></el-table-column>
        <el-table-column
          prop="siteCount"
          label="收单员人数"
          width="200"
        ></el-table-column>
        <el-table-column prop="lineRulesCount" label="收单规则数" width="200">
        </el-table-column>
        <el-table-column label="操作">
          <template v-slot="scope">
            <el-button type="text" class="font-size12" @click="showDetail(scope.row)"
              >查看</el-button
            >
            <el-button type="text" class="font-size12" @click="del(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:1
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */

import axios from "@/api/axiosNew";
import api from "@/api/base.new.api";
export default {
  data() {
    return {
      dataList: [],
      ruleCode: "",
    };
  },
  created() {
    this.ruleCode = this.$route.params.ruleCode;
    this.fetchData();
  },
  methods: {
    async fetchData() {
      let res = await axios.post(api.receiveSiteListByCode, { ruleCode: this.ruleCode });
      this.dataList = res.data.sites;
    },
    showDetail(item) {
      this.$router.push({
        path: "/companyRecipientAdd",
        query: { siteCode: item.siteCode },
      });
      // this.$router.push({ name: 'companyRecipientDetail', query: { siteCode: item.siteCode } });
    },
    del(item) {
      this.$confirm("是否删除该节点?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await axios.post(api.compensateFreightDeleteSite, { siteCode: item.siteCode });
          this.$message.success("删除成功");
          this.fetchData();
        })
        .catch(() => {});
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
